import React from 'react';
import {
  Modal,
  Button,
  ButtonVariant,
  Text,
  Box,
  TextArea,
} from '@usealloy/component-library';
import { useAppSelector } from '~/store/reduxHooks';
import { selectCustomListByActionPublicId } from 'flow/store/redux/selectors';


type UpdateToActiveListModalProps = {
  isOpen: boolean;
  onClose: () => void;
  onUpdate: () => void;
  nodeId: string;
};

const UpdateToActiveListModal: React.FC<UpdateToActiveListModalProps> = ({
  isOpen,
  onClose,
  onUpdate,
  nodeId,
}) => {
  const selectedCustomList = useAppSelector(selectCustomListByActionPublicId(nodeId));

  if (!selectedCustomList) return null;

  const { currentVersion, activeVersion } = selectedCustomList;
  if (!currentVersion || !activeVersion) return null;

  const currentVersionNumber = currentVersion.major_version;
  const activeVersionNumber = activeVersion.major_version;

  const versionNotes = activeVersion.notes;

  return (
    <Modal
      header="Update to Active Version"
      size="large"
      isOpen={isOpen}
      onClose={onClose}
      hasCloseIcon
      primaryAction={(
        <Button
          onClick={onUpdate}
          variant={ButtonVariant.primary}
        >
          Update and Review Dependencies
        </Button>
        )}
      secondaryAction={(
        <Button
          onClick={onClose}
          variant={ButtonVariant.secondary}
        >
          Cancel
        </Button>
        )}
      footerBannerContent="Updating version will take you to the Dependencies tab to review dependencies and downstream logic."
      footerBannerVariant="info"
      contentStyle={{ padding: 'var(--cl-space-2) var(--cl-space-6) var(--cl-space-7)' }}
    >
      <Box direction="column" justifyContent="flex-start" gap={5}>
        <Box direction="row" justifyContent="flex-start">
          <Text size={3}>
            You can only update to the active available version at this time. View the notes
            (if any) from <b>v{currentVersionNumber}</b> to <b>v{activeVersionNumber}</b>.
          </Text>
        </Box>
        <TextArea
          label="Version Notes"
          value={versionNotes}
          disabled
          style={{ cursor: 'default' }}
          placeholder="No notes available for this version"
          rows={4}
        />
      </Box>
    </Modal>
  );
};

export default UpdateToActiveListModal;
